import { DragLayerMonitorProps } from "@minoru/react-dnd-treeview";
import FolderIcon from "@mui/icons-material/Folder";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import { Box } from "@mui/material";
import React from "react";
import { TagFromTree } from "../../../models/TrendingModelsV2";

type Props = {
	monitorProps: DragLayerMonitorProps<TagFromTree>;
};

export const CustomDragPreview: React.FC<Props> = (props) => {
	const item = props.monitorProps.item;
	const isFolder = item.data?.TagTypeCode === "F" ? true : false;

	return (
		<Box
			sx={{
				alignItems: "center",
				backgroundColor: "#1967d2",
				borderRadius: "4px",
				boxShadow:
					" 0 12px 24px -6px rgba(0, 0, 0, .25); 0 0 0 1px rgba(0, 0, 0, .08)",
				color: "#fff",
				display: "inline-grid",
				fontSize: "0.875rem",
				gap: "8px",
				gridTemplateColumns: "auto auto",
				padding: "4px 8px",
				pointerEvents: "none",
			}}
		>
			<Box
				sx={{
					alignItems: "center",
					display: "flex",
				}}
			>
				{isFolder ? <FolderIcon /> : <InsertChartIcon fontSize="small" />}
			</Box>
			<Box
				sx={{
					alignItems: "center",
					display: "flex",
				}}
			>
				{item.data?.Alias || item.data?.TagName}
			</Box>
		</Box>
	);
};
